import { useToast } from '@cad-arc';
import { useApiClient } from '~/api-client';
import { ApiResult, ApiResultReleaseUnitsResponse, ReleaseUnitsResource } from '@mark43/cad-api';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse, AxiosError } from 'axios-cad-nx';

export function useUnassignSelfMutation({
    onMutationSuccess,
}: {
    onMutationSuccess?: (data: AxiosResponse<ApiResultReleaseUnitsResponse>) => void;
}) {
    const apiClient = useApiClient();
    const toast = useToast();

    const mutation = useMutation(
        (unitIds: number[]) => {
            return apiClient.request<ReleaseUnitsResource.ReleaseUnits>({
                method: 'POST',
                url: `release_units/`,
                data: {
                    unitIds,
                    actingTransitioner: 'FIRST_RESPONDER',
                },
            });
        },
        {
            onSuccess(data) {
                onMutationSuccess?.(data);
            },
            onError: (e: AxiosError<ApiResult>) => {
                toast({
                    description: e?.response?.data?.error,
                    status: 'error',
                });
            },
        }
    );
    return mutation;
}
